/* eslint-disable no-undef */
import GammaContractsRegistry from "../../abis/GammaContractsRegistry.json";
import MarketFactory from "../../abis/MarketFactory.json";
import IMarketRegistry from "../../abis/IMarketRegistry.json";
import UserBalances from "../../abis/UserBalances.json";
import UserBalancesVault from "../../abis/UserBalancesVault.json";
import DateUtils from "../../abis/DateUtils.json";
import IPriceUtils from "../../abis/IPriceUtils.json";
import DyDxMath from "../../abis/DyDxMath.json";
import IUniswapAdapter from "../../abis/IUniswapAdapter.json";
import TokenRegistry from "../../abis/TokenRegistry.json";
import PositionsManager from "../../abis/PositionsManager.json";
import MarginPool from "../../abis/MarginPool.json";
import InterestRateModel from "../../abis/InterestRateModel.json";
import LoadHelper from "../../abis/LoadHelper.json";
import LPManager from "../../abis/LPManager.json";
import SettlementManager from "../../abis/SettlementManager.json";
import VolRangeMarketSingleton from "../../abis/VolRangeMarketSingleton.json";
import { setWETHAddress } from "./tokensInteractions";
import { handleNewError } from "./errorInteractions";

export const isSupportedNetwork = async (networkId, dispatch) => {
  if (GammaContractsRegistry.networks[networkId] === undefined) {
    handleNewError({}, "", 1, dispatch, true);
    return false;
  }

  return true;
};

export const loadContracts = async (web3, networkId, dispatch) => {
  try {
    // load gamma contracts registry
    const gammaContractsRegistry = new web3.eth.Contract(GammaContractsRegistry.abi, GammaContractsRegistry.networks[networkId].address);
    // load other contracts
    const contractNames = [
      "UniswapAdapter",
      "MarketRegistry",
      "MarketFactory",
      "DateUtils",
      "PriceUtils",
      "DyDxMath",
      "UserBalances",
      "TokenRegistry",
      "PositionsManager",
      "MarginPool",
      "InterestRateModel",
      "LoadHelper",
      "LPManager",
      "SettlementManager",
      "VolRangeMarketSingleton",
      "UserBalancesVault",
      "WETH"
    ];
    const addresses = await gammaContractsRegistry.methods.getMultiple(contractNames).call();

    const uniswapAdapter = new web3.eth.Contract(IUniswapAdapter.abi, addresses[0]);
    const marketRegistry = new web3.eth.Contract(IMarketRegistry.abi, addresses[1]);
    const marketFactory = new web3.eth.Contract(MarketFactory.abi, addresses[2]);
    const dateUtils = new web3.eth.Contract(DateUtils.abi, addresses[3]);
    const priceUtils = new web3.eth.Contract(IPriceUtils.abi, addresses[4]);
    const dydxMath = new web3.eth.Contract(DyDxMath.abi, addresses[5]);
    const userBalances = new web3.eth.Contract(UserBalances.abi, addresses[6]);
    const tokenRegistry = new web3.eth.Contract(TokenRegistry.abi, addresses[7]);
    const positionsManager = new web3.eth.Contract(PositionsManager.abi, addresses[8]);
    const marginPool = new web3.eth.Contract(MarginPool.abi, addresses[9]);
    const interestRateModel = new web3.eth.Contract(InterestRateModel.abi, addresses[10]);
    const loadHelper = new web3.eth.Contract(LoadHelper.abi, addresses[11]);
    const lpManager = new web3.eth.Contract(LPManager.abi, addresses[12]);
    const settlementManager = new web3.eth.Contract(SettlementManager.abi, addresses[13]);
    const volRangeMarketSingleton = new web3.eth.Contract(VolRangeMarketSingleton.abi, addresses[14]);
    const userBalancesVault = new web3.eth.Contract(UserBalancesVault.abi, addresses[15]);

    setWETHAddress(addresses[16], dispatch);

    const contracts = {
      gammaContractsRegistry,
      uniswapAdapter,
      marketRegistry,
      marketFactory,
      dateUtils,
      priceUtils,
      dydxMath,
      userBalances,
      tokenRegistry,
      positionsManager,
      marginPool,
      interestRateModel,
      loadHelper,
      lpManager,
      settlementManager,
      volRangeMarketSingleton,
      userBalancesVault
    };

    return contracts;
  } catch (e) {
    handleNewError({}, "", 1, dispatch, true);
  }
};
